import clsx from 'clsx'
import { useState } from 'react'
import { useIntl } from 'react-intl'

import { type MeetingDomain } from '../../types/domain/meeting-domain'
import { Meeting } from './Meeting'

interface MeetingsTableMobileProps {
  meetings: MeetingDomain[]
  messageSpace: boolean
}

export const MeetingListingMobile = ({
  meetings,
  messageSpace,
}: MeetingsTableMobileProps) => {
  const [currentStatus, setCurrentStatus] = useState<
  'start' | 'profile' | 'availability' | 'scheduled' | 'accomplished' | 'canceled' | 'refused' | 'onhold' | 'finished'
  >(
    'scheduled'
  )
  const { formatMessage } = useIntl()

  return (
    <div className="h-[calc(100vh_-_310px)]">
      <header className="flex gap-2 mb-6">
        <button
          className={clsx(
            'w-full py-3 flex-1 rounded-lg text-xs lg:text-base font-semibold',
            currentStatus === 'scheduled'
              ? 'bg-primary-light text-white'
              : 'bg-grey-300 text-grey-700'
          )}
          onClick={() => setCurrentStatus('scheduled')}
        >
          {formatMessage({ id: 'NEXT_MEETINGS' })}
        </button>
        <button
          className={clsx(
            'w-full py-3 flex-1 rounded-lg text-xs lg:text-base font-semibold',
            currentStatus === 'accomplished' ||
              currentStatus === 'canceled' ||
              currentStatus === 'refused' ||
              currentStatus === 'finished'
              ? 'bg-primary-light text-white'
              : 'bg-grey-300 text-grey-700'
          )}
          onClick={() => setCurrentStatus('accomplished')}
        >
          {formatMessage({ id: 'COMPLETED_METTINGS' })}
        </button>
      </header>

      <ul
        className={clsx('overflow-y-auto', {
          'max-h-[calc(100vh_-_360px)]': messageSpace,
          'max-h-[calc(100vh_-_230px)]': !messageSpace,
        })}
      >
        {meetings.filter((metting) => metting.status === currentStatus).length >
        0 ? (
          <>
            {meetings
              .filter((metting) => metting.status === currentStatus)
              .map((meeting) => (
                <li key={meeting.id} className="mb-3">
                  <Meeting meeting={meeting} />
                </li>
              ))}
          </>
            ) : (
          <>
            {(currentStatus === 'start' || currentStatus === 'profile' || currentStatus === 'availability' || currentStatus === 'scheduled' || currentStatus === 'onhold') && (
              <p className="mt-3 text-center text-grey-700 text-sm">
                {formatMessage({ id: 'NO_MEETING_SCHEDULED' })}
              </p>
            )}
            {(currentStatus === 'accomplished' || currentStatus === 'canceled' || currentStatus === 'refused' || currentStatus === 'finished') && (
              <p className="mt-3 text-center text-grey-700 text-sm">
                {formatMessage({ id: 'NO_MEETING_COMPLETED' })}
              </p>
            )}
          </>
            )}
      </ul>
    </div>
  )
}
